import type { KibLabelVariants } from '@chewy/kib-label-react'

import { PrescriptionDeclineReasonType } from './PrescriptionWorkflow'

export enum OrderDisplayStatus {
  APPROVED = 'APPROVED',
  FILLED = 'FILLED',
  SHIPPED = 'SHIPPED',
  DELIVERED = 'DELIVERED',
  PENDING_PHARMACIST_REVIEW = 'PENDING_PHARMACIST_REVIEW',
  /** Order status: pending vet review (API state PENDING). */
  PENDING_VET_REVIEW = 'PENDING_VET_REVIEW',
  DECLINED_PET_NEEDS_TO_BE_SEEN = 'DECLINED_PET_NEEDS_TO_BE_SEEN',
  DECLINED_WRONG_PRODUCT = 'DECLINED_WRONG_PRODUCT',
  DECLINED_NOT_A_CLINIC_PATIENT = 'DECLINED_NOT_A_CLINIC_PATIENT',
  DECLINED_OTHER = 'DECLINED_OTHER',
  PHARMACIST_DECLINED = 'PHARMACIST_DECLINED',
  CANCELED = 'CANCELED',
}

export const OrderDisplayStatusToVariant: Record<
  OrderDisplayStatus,
  KibLabelVariants
> = {
  [OrderDisplayStatus.APPROVED]: 'success',
  [OrderDisplayStatus.FILLED]: 'success',
  [OrderDisplayStatus.SHIPPED]: 'success',
  [OrderDisplayStatus.DELIVERED]: 'success',
  [OrderDisplayStatus.PENDING_PHARMACIST_REVIEW]: 'default',
  [OrderDisplayStatus.PENDING_VET_REVIEW]: 'default',
  [OrderDisplayStatus.DECLINED_PET_NEEDS_TO_BE_SEEN]: 'danger',
  [OrderDisplayStatus.DECLINED_WRONG_PRODUCT]: 'danger',
  [OrderDisplayStatus.DECLINED_NOT_A_CLINIC_PATIENT]: 'danger',
  [OrderDisplayStatus.DECLINED_OTHER]: 'danger',
  [OrderDisplayStatus.PHARMACIST_DECLINED]: 'danger',
  [OrderDisplayStatus.CANCELED]: 'danger',
}

export const DeclineReasonToOrderDisplayStatus: Partial<
  Record<PrescriptionDeclineReasonType, OrderDisplayStatus>
> = {
  [PrescriptionDeclineReasonType.PET_NEEDS_TO_BE_SEEN]:
    OrderDisplayStatus.DECLINED_PET_NEEDS_TO_BE_SEEN,
  [PrescriptionDeclineReasonType.WRONG_PRODUCT]:
    OrderDisplayStatus.DECLINED_WRONG_PRODUCT,
  [PrescriptionDeclineReasonType.NOT_A_CLINIC_PATIENT]:
    OrderDisplayStatus.DECLINED_NOT_A_CLINIC_PATIENT,
  [PrescriptionDeclineReasonType.OTHER]: OrderDisplayStatus.DECLINED_OTHER,
}
